import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  color: var(--black);
  text-align: center;
  background-color: var(--white);
  height: 100%;
  width: 100%;
`;

export const Title = styled.h1`
  height: 100%;
  width: 100%;
  padding: 130px 158px 0 158px;
  font-family: "Noto Sans Thai";
  line-height: 150px;
  font-size: clamp(30px, 9vw, 64px);
  text-align: left;

  @media only screen and (max-width: 414px) {
    line-height: 60px;
    padding: 130px 50px 0 50px !important;
    margin: 0;
  }

  @media screen and (min-width: 375px) and (max-width: 667px) and (orientation: landscape) {
    line-height: 60px;
    padding: 150px 50px 0 50px !important;
    margin: 0;
  }

  @media screen and (min-width: 414px) and (max-width: 896px) and (orientation: landscape) {
    line-height: 60px;
    padding: 150px 50px 0 50px !important;
    margin: 0;
  }

  @media only screen and (max-width: 820px) {
    line-height: 60px;
    padding: 150px 158px 0 105px;
    margin: 0;
  }
`;

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 50px;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0 158px 50px 158px;

  @media only screen and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 13%;
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
    padding: 13%;
  }

  @media only screen and (width: 1024px) and (orientation: portrait) {
    padding: 0 13%;
  }

  @media only screen and (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media screen and (min-width: 411px) and (max-width: 823px) and (orientation: landscape) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: 320px) and (max-width: 568px) and (orientation: landscape) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media only screen and (min-width: 823px) and (max-width: 411px) and (orientation: landscape) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (min-width: 1080px) and (max-width: 1980px) and (orientation: portrait) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media only screen and (min-width: 1024px) and (max-width: 1366px) and (orientation: landscape) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media only screen and (min-width: 375px) and (max-width: 667px) and (orientation: landscape) {
    padding: 9% !important;
  }

  @media only screen and (min-width: 414px) and (max-width: 896px) and (orientation: landscape) {
    padding: 6%;
  }
`;

export const Href = styled(Link)`
  color: white;
  width: 100%;
  justify-content: center;
  display: flex;
`;
